import { IntermindError } from './common/models/IntermindError';

export interface IntermindConfig {
  apiPath: string;
  wsPath: string;
  apiToken: () => Promise<string>;
  onError?: (error: IntermindError) => void;
  customRequestHeaders?: () => Promise<Record<string, string>>;
  locale?: string;
}

class Config {
  private static instance: Config;
  private config: IntermindConfig;

  private constructor() {
    this.config = {
      apiPath: '/api',
      wsPath: '/api/ws',
      apiToken: async () => '',
      locale: 'en',
    };
  }

  static getInstance(): Config {
    if (!Config.instance) {
      Config.instance = new Config();
    }
    return Config.instance;
  }

  async setConfig(config: Partial<IntermindConfig>) {
    this.config = { ...this.config, ...config };
  }

  get<K extends keyof IntermindConfig>(key: K): IntermindConfig[K] {
    return this.config[key];
  }
}

export const intermindConfig = Config.getInstance();
